import { Suspense } from 'react';
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import { useMyContext } from '../../pages/provider';
import Loader from '../../routes/Loader';

const TawkMessenger = () => {
  const { propertyId, widgetId } = useMyContext();

  // useEffect(() => {
  //   console.log('Initializing Tawk Messenger');
    
  //   const initializeTawk = setInterval(() => {
  //     if (window.Tawk_API) {
  //       clearInterval(initializeTawk);
  //       console.log('Tawk_API is ready');

  //       window.Tawk_API.onLoad = function () {
  //         console.log('Tawk Messenger Loaded');

  //         // Apply custom styles via the Tawk API
  //         window.Tawk_API.customStyle = {
  //           visibility: {
  //             desktop: {
  //               position: 'br', // Bottom-right
  //               xOffset: '60px', // Horizontal offset
  //               yOffset: 20,     // Vertical offset
  //             },
  //             mobile: {
  //               position: 'br',
  //               xOffset: 0,
  //               yOffset: 0,
  //             },
  //             bubble: {
  //               rotate: '0deg',
  //               xOffset: -20,
  //               yOffset: 0,
  //             },
  //           },
  //         };
  //       };
  //     }
  //   }, 500);

  //   // Clean up interval on unmount
  //   return () => clearInterval(initializeTawk);
  // }, []);

  return (
    <Suspense fallback={<Loader />}>
      {propertyId && widgetId && (
        <TawkMessengerReact propertyId={propertyId} widgetId={widgetId} />
      )}
    </Suspense>
  );
};

export default TawkMessenger;
